import React from 'react'
import Footer from './Footer'
import Header from './Header'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import ProtectedContent from './ProtectedContent'



class ProfessionalDevelopment extends React.Component {


  render() {

    return(

      <div>
        <Header />

        <div className="container">

          { (Object.keys(this.props.user).length) 

          ?

          <div>

            <h1 style={{marginTop: '30px', textAlign: 'center', marginBottom: '5px'}}>Professional Development</h1>
            <p style={{textAlign: 'center', marginTop: '0px', color: '#816992'}}>Please note that the training featured here took place in 2018.</p>

            <p style={{textAlign: 'center', marginTop: '30px'}}>Choose your level</p>

            <div style={{textAlign: 'center', marginBottom: 40}}>
            <Link to="professional-development-primary"><button className="hollow-purple-button" style={{marginRight: 10}}>Primary</button></Link>
            <Link to="professional-development-secondary"><button className="hollow-purple-button" style={{marginLeft: 10}}>Secondary</button></Link>
            </div>

            <div style={{textAlign: 'center', marginBottom: 100}}>
              <p style={{textAlign: 'center'}}>Or view photos from our CPD sessions</p>
              <Link to="photos"><button className="hollow-purple-button" style={{marginRight: 10}}>View photos</button></Link>
            </div>

          </div>

          :

          <ProtectedContent />
          

          }

          

        </div>



        <Footer />

      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
      user: state.user
  };
};

export default connect(mapStateToProps)(ProfessionalDevelopment)
  



// WEBPACK FOOTER //
// ./src/components/ProfessionalDevelopment.js